import api from "./axios";

class ServiceProductionOrder {
  async save(productionOrder) {
    const { data } = await api.post("/production-order", productionOrder)
    return data
  }

  async update(productionOrder) {
    await api.put(`/production-order/${productionOrder.id}`, productionOrder);
  }

  async updateSituation(id, situacao) {
    await api.patch(`/production-order/${id}`, situacao);
  }

  async findById(id) {
    const { data } = await api.get(`/production-order/${id}`)
    return data;
  }

  async delete(id) {
    await api.delete(`/production-order/${id}`)
  }

  async deleteAll(id) {
    await api.delete(`/production-order/all/${id}`)
  }

  async list(text, type, situation = '', startDate, endDate, page = 1,) {
    const { data } = await api.get(`/production-order?q=${text}&type=${type}&situation=${situation}&startDate=${startDate}&endDate=${endDate}&page=${page}`)

    return data
  }

  async generateSaleSquareMeter(id) {
    const { data } = await api.post(`/production-order/generate/sale/square-meter/${id}`)

    return data
  }

  async duplicate(id) {
    const { data } = await api.get(`/production-order/duplicate/${id}`)

    return data
  }
}
export default new ServiceProductionOrder()